import { parseElementFromString } from 'anodum';
import hdrm from '../../hdrm';
import site from '../../site';
import clipboard from '../../clipboard';
import actionTypes from '../constants/action-types';
import globals from '../../globals';
import blockTemplates from '../../block-templates';
import blocks from '../../blocks';
import { UPDATE_STATIC_ONLY, UPDATE_LIVE_ONLY } from '../../hdrm/constants/update-strategies';

const getClipboardOptions = (state) => {
  const clipboardData = clipboard.selectors.getClipboardData(state);
  const { element, options: initialOptions } = clipboardData;
  let { strategy } = initialOptions;

  const pageId = site.selectors.getActivePageId(state);
  const blockId = blocks.accessors.getBlockIdByElement(element);

  if (blockId && !blocks.verifiers.isBlockOnPage(blockId, pageId)) {
    const { templateId } = blocks.selectors.getBlock(state, blockId);
    const blockTemplate = blockTemplates.selectors.getBlockTemplateById(state, templateId);
    const dependencies = blockTemplate
      ? Object.values(blockTemplate.dependencies).filter(Boolean)
      : [];
    const isViewReloadRequired = Boolean(dependencies.length);

    if (isViewReloadRequired) {
      strategy = UPDATE_STATIC_ONLY;
    }
  }

  return {
    ...initialOptions,
    strategy,
  };
};

const handlePasteElement = (store, action) => {
  const { refElementId, position } = action.payload;
  const state = store.getState();
  const clipboardData = clipboard.selectors.getClipboardData(state);
  const { element } = clipboardData;
  const { strategy } = getClipboardOptions(state);

  if (!element) return null;

  return hdrm.operations.insertElement(
    parseElementFromString(element.outerHTML),
    refElementId,
    position,
    strategy
  );
};

const pasteElement = (store) => (next) => (action) => {
  switch (action.type) {
    case actionTypes.BULK_VIEW_ACTIONS: {
      const actions = action.payload.actions.filter(
        (targetAction) => targetAction.type === actionTypes.PASTE_ELEMENT
      );

      actions.forEach((targetAction) => {
        handlePasteElement(store, targetAction);
      });

      next(action);
      break;
    }

    case actionTypes.PASTE_ELEMENT: {
      const { globalsToUpdate, options } = action.payload;
      const state = store.getState();

      const newHTML = handlePasteElement(store, action);

      if (!newHTML) next(action);

      const clipboardOptions = getClipboardOptions(state);
      const isViewReloadRequired = globals.verifiers.hasGlobals(newHTML);
      let { strategy } = clipboardOptions;

      if (isViewReloadRequired) {
        strategy = UPDATE_STATIC_ONLY;
      }

      if (strategy !== UPDATE_LIVE_ONLY) {
        const pageId = site.selectors.getActivePageId(state);

        globals.helpers.saveGlobals(globalsToUpdate);
        store.dispatch(site.actions.setPageHTML(pageId, newHTML));
      }

      next({
        ...action,
        payload: {
          ...action.payload,
          options: { ...options, ...clipboardOptions, strategy },
        },
      });

      break;
    }
    default:
      next(action);
  }
};

export default pasteElement;
